import {
  ButtonERP,
  ChipsContainer,
  CustomPanel,
  DropdownPrimeReact,
  TableERP,
  Tabs,
} from "@finanedi.es/storybook"
import { faAngleDown, faAngleRight } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  useCuentaContableEmpresaCompra,
  useCuentaContableEmpresaIvaCompra,
  useCuentaContableEmpresaRetencionCompra,
} from "api/CuentaContableEmpresa.hook"
import {
  useCuentaContableCuentaCompra,
  useCuentaContableCuentaIvaCompra,
  useCuentaContableCuentaRetencionCompra,
} from "api/CuentaContable_Cuenta.hook"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import { DropdownCuentasContablesConModal } from "common/components/DropdownsCuentasContables/DropdownCuentasContablesConModal/DropdownCuentasContablesConModal"
import Spinner from "common/components/Spinner"
import { validacionesSelector } from "features/Documentos/redux/documentosSlice"
import { useSelector } from "hooks/useSelector"
import { DropdownChangeParams } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"
import { Message } from "primereact/message"
import { Skeleton } from "primereact/skeleton"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import {
  AprobarDocumentoProps,
  Data,
  SubData,
  TYPES_IMPUESTOS,
  TYPE_TAXES,
} from "../../../constant"
import { DETALLES_DOCUMENTOS_COLUMNS } from "../../../constants/AprobarDocumentosDetalleImpuestosColumns"
import { DETALLES_TOTAL_DOCUMENTOS_COLUMNS } from "../../../constants/AprobarDocumentosDetalleTotalesComuns"
import DocumentDetailCard from "../DocumentDetailCard"
import DocumentValidation from "../DocumentValidation"

const AprobarDocumento: React.FC<AprobarDocumentoProps> = ({
  formik,
  validacionesSelected,
  isValidating,
  handleHide,
  tipoImpuestos,
  tabSelected,
  setTabSelected,
}) => {
  const { t } = useTranslation()
  const { activeCompany } = useUsuarioEmpresaActiva()
  const [categoryExpanded, setCategoryExpanded] = useState(true)
  const [flowExpanded, setFlowExpanded] = useState(true)

  const { validacion } = useSelector(validacionesSelector)

  const { cuentasContablesEmpresas: listaDeCuentasComprasBase } =
    useCuentaContableCuentaCompra()
  const {
    cuentasContablesEmpresas: listaDeCuentasCompras,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasCompras,
  } = useCuentaContableEmpresaCompra()

  const { cuentasContablesEmpresas: listaDeCuentasImpuestosComprasBase } =
    useCuentaContableCuentaIvaCompra()
  const {
    cuentasContablesEmpresas: listaDeCuentasImpuestosCompras,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasImpuestosCompras,
  } = useCuentaContableEmpresaIvaCompra()

  const { cuentasContablesEmpresas: listaDeCuentasRetencionComprasBase } =
    useCuentaContableCuentaRetencionCompra()
  const {
    cuentasContablesEmpresas: listaDeCuentasRetencionCompras,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasRetencionesCompras,
  } = useCuentaContableEmpresaRetencionCompra()

  const handleSelect = ({ value }: { value: number }) => {
    formik.setFieldValue("estadoRevision", value)
  }

  const handleChange = ({ target }: React.ChangeEvent<HTMLTextAreaElement>) => {
    formik.setFieldValue("comentario", target.value)
  }

  const renderDetallesTaxes = (
    tipoTax: number,
    datos: Data | undefined
  ): JSX.Element => {
    const tipo =
      tipoTax === TYPES_IMPUESTOS.IMPUESTOS ? "impuestos" : "retenciones"

    return datos?.[tipo] ? (
      <div>
        {datos?.[tipo].map((detalle: SubData, index: number) => (
          <div
            key={`title${tipo}-${index + 1}`}
            className={`tw-w-full ${index !== 0 ? "tw-mt-6" : ""}`}
          >
            <p className='tw-w-full tw-text-left tw-font-medium !tw-text-sm'>
              {tipo === TYPE_TAXES.impuestos
                ? `${t("validaciones.documentos.detail.taxImp")} `
                : `${t("validaciones.documentos.detail.taxRet")} `}
              {index + 1}
            </p>
            {tipoTax === TYPES_IMPUESTOS.IMPUESTOS &&
              activeCompany.id === formik.values.empresaCreadoraId && (
                <DropdownPrimeReact
                  id='impuestoEmpresaId'
                  name='impuestoEmpresaId'
                  className={`!tw-w-full !tw-h-10 ${
                    formik.touched[tipo] &&
                    formik?.touched?.[tipo]?.[index]?.impuestoEmpresaId &&
                    formik.errors?.[tipo]?.[index]?.impuestoEmpresaId
                      ? "tw-border-danger"
                      : ""
                  }`}
                  onChange={(e) =>
                    formik.setFieldValue(
                      `${tipo}[${index}].impuestoEmpresaId`,
                      e.value
                    )
                  }
                  value={detalle.impuestoEmpresaId}
                  optionLabel='nombre'
                  optionValue='id'
                  placeholder='Seleccionar tipo de iva'
                  options={tipoImpuestos ?? []}
                />
              )}
            <TableERP
              columns={DETALLES_DOCUMENTOS_COLUMNS(t, tipo)}
              className='tw-h-fit'
              columnResizeMode='expand'
              value={[detalle]}
              showGridlines
              dataKey='id'
              lazy
              scrollable
              size='small'
            />
            <p className='tw-w-full tw-text-left tw-mb-2 tw-mt-4 !tw-text-sm'>
              {t("validaciones.documentos.detail.accounting")}
            </p>
            <div
              className={`tw-w-full ${
                formik.touched[tipo] &&
                formik?.touched?.[tipo]?.[index]?.cuentaContableId &&
                formik.errors?.[tipo]?.[index]?.cuentaContableId
                  ? "tw-border-danger tw-border tw-rounded-md hover:!tw-border-danger"
                  : ""
              }`}
            >
              <DropdownCuentasContablesConModal
                cuentasContablesOptions={
                  tabSelected === 0
                    ? listaDeCuentasImpuestosCompras
                    : listaDeCuentasRetencionCompras
                }
                dropdownValue={detalle?.cuentaContableId}
                onChange={(newCuentaContable: DropdownChangeParams) => {
                  formik.setFieldValue(
                    `${tipo}[${index}].cuentaContableId`,
                    newCuentaContable.value
                  )
                }}
                listaDeCuentasBase={
                  tabSelected === 0
                    ? listaDeCuentasImpuestosComprasBase
                    : listaDeCuentasRetencionComprasBase
                }
                refreshFetchData={
                  tabSelected === 0
                    ? refresListaDeCuentasImpuestosCompras
                    : refresListaDeCuentasRetencionesCompras
                }
                panelClassName='!tw-text-sm'
              />
            </div>
          </div>
        ))}
        <div
          className={`tw-w-full tw-mt-6 tw-flex ${
            tipo === TYPE_TAXES.impuestos
              ? "tw-justify-end"
              : "tw-justify-between"
          }`}
        >
          {tipo !== TYPE_TAXES.impuestos && (
            <ButtonERP
              onClick={() => {
                setTabSelected(tabSelected - 1)
              }}
              customize={{
                size: "md",
                type: "transparent",
              }}
              type='button'
              label={`${t("validaciones.documentos.detail.previous")}`}
            />
          )}
          <ButtonERP
            customize={{
              size: "md",
              type: "primary",
            }}
            label={`${t("validaciones.documentos.detail.next")}`}
            type='submit'
          />
        </div>
      </div>
    ) : (
      <div
        className={`tw-w-full tw-mt-6 tw-flex ${
          tipo === TYPE_TAXES.impuestos
            ? "tw-justify-end"
            : "tw-justify-between"
        }`}
      >
        {tipo !== TYPE_TAXES.impuestos && (
          <div
            className='tw-w-40 tw-flex tw-justify-center tw-items-center tw-h-12'
            onClick={() => {
              setTabSelected(tabSelected - 1)
            }}
          >
            {t("validaciones.documentos.detail.previous")}
          </div>
        )}

        <ButtonERP
          customize={{
            size: "md",
            type: "primary",
          }}
          label={`${t("validaciones.documentos.detail.next")}`}
          type='button'
          onClick={() => {
            setTabSelected(tabSelected + 1)
          }}
        />
      </div>
    )
  }

  const renderDetallesDatail = (datos: Data | undefined): JSX.Element => {
    return (
      <div>
        <div className='tw-w-full tw-shadow-md tw-rounded tw-bg-simple-10 tw-p-4'>
          <p className='tw-w-full tw-text-left tw-font-medium tw-text-sm'>
            {t("validaciones.documentos.detail.financialSumary")}
          </p>
          <TableERP
            columns={DETALLES_TOTAL_DOCUMENTOS_COLUMNS(t)}
            className='tw-h-fit'
            columnResizeMode='expand'
            value={[
              {
                text: `${t("validaciones.documentos.detail.totalTaxable")}`,
                number: datos?.subtotal,
              },
              {
                text: `${t("validaciones.documentos.detail.invoiceAmmount")}`,
                number: datos?.importe,
              },
            ]}
            showGridlines
            dataKey='id'
            lazy
            scrollable
            size='small'
          />

          <p className='tw-w-full tw-text-left tw-mb-2 tw-mt-4 tw-text-sm'>
            {t("validaciones.documentos.detail.purchadesAccount")}
          </p>
          <div
            className={`tw-w-full ${
              formik?.touched?.cuentaContableId &&
              formik.errors?.cuentaContableId
                ? "tw-border-danger tw-border tw-rounded-md"
                : ""
            }`}
          >
            <DropdownCuentasContablesConModal
              cuentasContablesOptions={listaDeCuentasCompras}
              dropdownValue={datos?.cuentaContableId ?? ""}
              onChange={(newCuentaContable: DropdownChangeParams) => {
                formik.setFieldValue(
                  "cuentaContableId",
                  newCuentaContable.value
                )
              }}
              listaDeCuentasBase={listaDeCuentasComprasBase}
              refreshFetchData={refresListaDeCuentasCompras}
            />
          </div>
          {formik.touched?.cuentaContableId &&
            formik.errors?.cuentaContableId && (
              <small className='tw-w-full tw-text-left p-error p-d-block tw-text-sm'>
                {formik.errors?.cuentaContableId}
              </small>
            )}
          <p className='tw-w-full tw-text-left tw-mb-2 tw-mt-4 tw-text-sm'>
            {t("validaciones.documentos.detail.dateOfEntry")}
          </p>
          <div
            className={`tw-w-full tw-flex tw-flex-col ${
              formik?.touched?.fecha && formik.errors?.fecha
                ? "tw-border-danger tw-border tw-rounded-md"
                : ""
            }`}
          >
            <InputText
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                formik.setFieldValue("fecha", e.target.value)
              }}
              value={formik.values.fecha}
              type='date'
              className='tw-w-full'
            />
          </div>
          {formik.touched?.fecha && formik.errors?.fecha && (
            <small className='tw-w-full tw-text-left p-error p-d-block'>
              {formik.errors?.fecha}
            </small>
          )}
        </div>
        <div className='tw-mt-4 !tw-text-sm'>
          <CustomPanel
            title={`${t(
              "validaciones.documentos.detail.invoiceClassification"
            )}`}
            expandIcon={<FontAwesomeIcon icon={faAngleRight} />}
            collapseIcon={<FontAwesomeIcon icon={faAngleDown} />}
            className='tw-cursor-pointer'
            collapsed={categoryExpanded}
            onToggle={(e) => setCategoryExpanded(e.value)}
            headerTemplate={({ element }) => (
              <div
                onClick={() => setCategoryExpanded((prevState) => !prevState)}
              >
                {element}
              </div>
            )}
          >
            <div className='tw-p-4'>
              <ChipsContainer
                addOnBlur
                max={5}
                placeholder={`${t("validaciones.documentos.detail.addTags")}`}
                maxLength={5}
                separator=','
                containerClassName='tw-w-full tw-h-10'
                className='tw-w-full'
                allowDuplicate={false}
                value={formik.values.listadoTags}
                onChange={(e) =>
                  formik.setFieldValue("listadoTags", e.target.value)
                }
              />
            </div>
          </CustomPanel>
        </div>
        <div className='tw-mt-4 !tw-text-sm'>
          <CustomPanel
            title={`${t("validaciones.documentos.detail.validationFlow")}`}
            expandIcon={<FontAwesomeIcon icon={faAngleRight} />}
            collapseIcon={<FontAwesomeIcon icon={faAngleDown} />}
            className='tw-cursor-pointer'
            collapsed={flowExpanded}
            onToggle={(e) => setFlowExpanded(e.value)}
            headerTemplate={({ element }) => (
              <div onClick={() => setFlowExpanded((prevState) => !prevState)}>
                {element}
              </div>
            )}
          >
            <DocumentDetailCard
              validacion={validacion}
              isVistaDetail
            />
          </CustomPanel>
        </div>
        <div className='tw-w-full tw-shadow-md tw-bg-simple-10 tw-mt-4'>
          <DocumentValidation
            documentsToValidate={validacionesSelected}
            dataToValidate={formik.values}
            handleSelect={handleSelect}
            handleChange={handleChange}
            isValidating={isValidating}
            handleHide={() => setTabSelected(tabSelected - 1)}
          />
        </div>
      </div>
    )
  }

  return (
    <div className='tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-start tw-bg-red tw-overflow-hidden'>
      {formik.values.lastSignature ? (
        <Message
          className='tw-w-full tw-h-12 tw-px-4 !tw-border !tw-border-info !tw-text-sm'
          severity='info'
          text={`${t("validaciones.infoLabel")}`}
        />
      ) : (
        <></>
      )}
      <div className='tw-w-full tw-h-full tw-overflow-y-auto tw-px-6 tw-pt-4'>
        <form onSubmit={formik.handleSubmit}>
          {formik.values ? (
            formik.values?.lastSignature === undefined ? (
              <Skeleton className='tw-w-full !tw-h-96 tw-rounded-md' />
            ) : formik.values?.lastSignature ? (
              <Tabs
                tabs={
                  formik.values.retenciones &&
                  formik.values.retenciones.length > 0 &&
                  formik.values.retenciones.every(
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (retencion: $TSMigrationFixMe) =>
                      retencion.porcentaje !== "-"
                  )
                    ? [
                        {
                          element: (
                            <span
                              key='1'
                              className={`tw-w-full tw-h-10 tw-flex tw-justify-center tw-items-center tw-mx-6 ${
                                tabSelected > 0 ? "!tw-text-text" : ""
                              } !tw-text-base`}
                              onClick={() => setTabSelected(0)}
                            >
                              {t("validaciones.labelTaxes")}
                            </span>
                          ),
                          disabled: false,
                        },
                        {
                          element: (
                            <span
                              key='2'
                              className={`tw-w-full tw-h-10 tw-flex tw-justify-center tw-items-center tw-mx-6 ${
                                tabSelected > 0
                                  ? "!tw-text-text"
                                  : "!tw-cursor-not-allowed"
                              } !tw-text-base`}
                              onClick={() =>
                                tabSelected > 1 && setTabSelected(1)
                              }
                            >
                              {t("validaciones.labelRetencion")}
                            </span>
                          ),
                          disabled: tabSelected < 1,
                        },
                        {
                          element: (
                            <span
                              key='3'
                              className={`tw-w-full tw-h-10 tw-flex tw-justify-center tw-items-center tw-mx-6 ${
                                tabSelected === 2
                                  ? "!tw-text-text"
                                  : "!tw-cursor-not-allowed"
                              } !tw-text-base`}
                            >
                              {t("validaciones.labelResumen")}
                            </span>
                          ),
                          disabled: tabSelected !== 2,
                        },
                      ]
                    : [
                        {
                          element: (
                            <span
                              key='1'
                              className={`tw-w-full tw-h-10 tw-flex tw-justify-center tw-items-center tw-mx-6 ${
                                tabSelected > 0 ? "!tw-text-text" : ""
                              } !tw-text-base`}
                              onClick={() => setTabSelected(0)}
                            >
                              {t("validaciones.labelTaxes")}
                            </span>
                          ),
                          disabled: false,
                        },
                        {
                          element: (
                            <span
                              key='2'
                              className={`tw-w-full tw-h-10 tw-flex tw-justify-center tw-items-center tw-mx-6 ${
                                tabSelected === 0
                                  ? "!tw-cursor-not-allowed"
                                  : ""
                              } !tw-text-base`}
                            >
                              {t("validaciones.labelResumen")}
                            </span>
                          ),
                          disabled: tabSelected !== 1,
                        },
                      ]
                }
                tabSelected={tabSelected}
                tabTitle={[]}
                tabsContainerTailwind='!tw-bg-transparent tw-flex tw-flex-row tw-items-center tw-mb-4 !tw-text-text !tw-h-10'
                tabsTailwind=' tw-cursor-pointer tw-select-none tw-text-primary-50 tw-h-16 tw-flex tw-items-center tw-text-lg'
                tabsActiveTailwind='tw-cursor-pointer tw-select-none tw-text-primary tw-font-medium tw-border-0 tw-border-b-4 tw-border-solid tw-border-primary tw-h-16	tw-flex tw-items-center tw-text-lg'
                tabChild={
                  formik.values.retenciones &&
                  formik.values.retenciones.length > 0 &&
                  formik.values.retenciones.every(
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (retencion: $TSMigrationFixMe) =>
                      retencion.porcentaje !== "-"
                  )
                    ? [
                        ...[
                          <div
                            key='1'
                            className='tw-bg-simple-10 tw-p-4 tw-rounded tw-shadow'
                          >
                            <div className='tw-flex tw-flex-col'>
                              {renderDetallesTaxes(
                                TYPES_IMPUESTOS.IMPUESTOS,
                                formik.values
                              )}
                            </div>
                          </div>,
                        ],
                        ...[
                          <div
                            key='2'
                            className='tw-bg-simple-10 tw-p-4 tw-rounded tw-shadow'
                          >
                            <div className='tw-flex tw-flex-col'>
                              {renderDetallesTaxes(
                                TYPES_IMPUESTOS.RETENCIONES,
                                formik.values
                              )}
                            </div>
                          </div>,
                        ],
                        ...[
                          <div
                            key='3'
                            className=''
                          >
                            <div className='tw-flex tw-flex-col'>
                              {renderDetallesDatail(formik.values)}
                            </div>
                          </div>,
                        ],
                      ]
                    : [
                        ...[
                          <div
                            key='1'
                            className='tw-bg-simple-10 tw-p-4 tw-rounded tw-shadow'
                          >
                            <div className='tw-flex tw-flex-col'>
                              {renderDetallesTaxes(
                                TYPES_IMPUESTOS.IMPUESTOS,
                                formik.values
                              )}
                            </div>
                          </div>,
                        ],

                        ...[
                          <div
                            key='3'
                            className=''
                          >
                            <div className='tw-flex tw-flex-col'>
                              {renderDetallesDatail(formik.values)}
                            </div>
                          </div>,
                        ],
                      ]
                }
              />
            ) : (
              <div>
                <DocumentValidation
                  documentsToValidate={validacionesSelected}
                  dataToValidate={formik.values}
                  handleSelect={handleSelect}
                  handleChange={handleChange}
                  isValidating={isValidating}
                  handleHide={handleHide}
                />
                <DocumentDetailCard
                  validacion={validacion}
                  isVistaDetail
                />
              </div>
            )
          ) : (
            <Spinner />
          )}
        </form>
      </div>
    </div>
  )
}

export default AprobarDocumento
